import type { ExplicitAddress } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSDK } from '@ui/utils';

export const useUnwrapTokens = (
  onSuccess?: (result: { hash?: string }) => void,
) => {
  const sdk = useSDK();
  const provider = currentWallet.useProvider();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ tokenAddress }: { tokenAddress: ExplicitAddress }) => {
      const signer = await provider?.getSigner();
      if (!signer) throw new Error('no signer');
      const bondingCurveModule = sdk.getBondingCurveModule(signer);
      const result = await bondingCurveModule.unwrapTokens(tokenAddress);
      return result;
    },
    {
      onSuccess: (result) => {
        queryClient.invalidateQueries({
          queryKey: ['useGraduatedTokens'],
        });
        const hash = result?.hash;
        onSuccess?.({ hash });
      },
    },
  );
};
